"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotDataType = void 0;
var SlotDataType;
(function (SlotDataType) {
    SlotDataType["GOAL"] = "goal";
    SlotDataType["TARGET"] = "target";
})(SlotDataType || (exports.SlotDataType = SlotDataType = {}));
